const utils = {
    numberToChinese(number) {
        const digit_arr = [
            "",
            "一",
            "二",
            "三",
            "四",
            "五",
            "六",
            "七",
            "八",
            "九",
        ];
        let chineseNumber;
        if (number < 10) {
            chineseNumber = digit_arr[number];
        } else if (number >= 10 && number < 20) {
            let arr = number.toString().split("");
            chineseNumber = number == 10 ? "十" : `十${digit_arr[arr[1]]}`;
        } else {
            let arr = number.toString().split("");
            chineseNumber = `${digit_arr[arr[0]]}十${digit_arr[arr[1]]}`;
        }
        return chineseNumber;
    }
}


export default utils